<template>
  <div>
    <div class="top_box">
      <span class="gsmc">《语文报》社有限责任公司</span>
    </div>
    <div class="in_box">
      <div class="con_1"></div>
      <div class="con_list">
        <ul>
          <li>订单号：{{out_trade_no}}</li>
          <li>投稿人姓名：{{username}}</li>
          <li>
            金额：
            <span class="spanyellpw spansize-24">{{total_fee}}元</span>
          </li>
		  <li>
            投稿类型：
            <span class="spanyellpw spansize-24">{{type}}</span>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
      <div align="center" id="qrcode">
        <div>
          <div id="qrCode" ref="qrCodeDiv"></div>
        </div>
        <br />
        <p id="hint" class="spansize-20">请使用微信“扫一扫”扫描二维码完成支付</p>
      </div>
    </div>
  </div>
</template>
<style>
* {
  padding: 0;
  margin: 0;
}

body {
  font-family: "宋体", Arial;
  font-size: 12px;
  text-align: left;
  background: #ececec;
  color: #878787;
  padding: 0px;
  margin: 0px;
}

.clear {
  clear: both;
  font-size: 1px;
  height: 0;
  visibility: hidden;
  line-height: 0;
}

.top_box {
  background: #04be02;
  height: 103px;
  text-align: center;
}
.gsmc {
  font-size: 35px;

  color: #fff;
  height: 100px;

  line-height: 100px;

  overflow: hidden;
}
.in_box {
  width: 800px;
  height: 500px;
  margin: 0 auto;
  background: #fff;

  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
}

.con_1 {
  background: #ffffff;
  height: 50px;
  -webkit-border-radius: 5px;
  border-radius: 5px 5px 0px 0px;
  -moz-border-radius: 5px;
}

.con_list {
  padding: 30px 20px 40px 20px;
}

.con_list ul li {
  float: left;
  width: 350px;
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: dotted 1px #cecece;
  height: 58px;
  line-height: 58px;
  font-size: 16px;
  color: #3f3f3f;
  overflow: hidden;
}

.spanyellpw {
  color: #ff6600;
}

.spansize-24 {
  font-size: 24px;
  font-weight: bold;
}
.spansize-20 {
  font-size: 15px;
}
</style>
<script>
import QRCode from "qrcodejs2";
import { GetPayResult } from "@/request/api";
export default {
  name: "qrCode",
  data() {
    return {
      out_trade_no: null,
      total_fee: null,
      username: null,
      type:null,
    };
  },
  created() {
    var that = this;
    var openid = sessionStorage.getItem("openid");
    that.username = sessionStorage.getItem("username");
    that.type = sessionStorage.getItem("type");
    if (openid == null) {
      this.$router.push({ path: "/" });
    }
    console.log(111111111111);
    if (that.username == 0) {
      that.$router.push({ path: "/userHome" });
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.bindQRCode();
    });
  },
  methods: {
    bindQRCode: function() {
      let _this = this;
      var code_url = sessionStorage.getItem("code_url");
      var out_trade_no = sessionStorage.getItem('out_trade_no');
      var total_fee = sessionStorage.getItem("total_fee");
      _this.out_trade_no = out_trade_no;
      _this.total_fee = total_fee / 100;
      var id = sessionStorage.getItem("id");
      console.log("code_url:", code_url);
      console.log("out_trade_no~~~~~~:", out_trade_no);
      new QRCode(this.$refs.qrCodeDiv, {
        text: code_url,
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
      GetPayResult({ out_trade_no: out_trade_no,total_fee: total_fee,username:sessionStorage.getItem("username"),workstype:this.type }).then(function(response) {
          console.log("支付结果：", response);
          if (response.data == "ok") {
            alert("支付成功！");
			_this.$router.push({ path: "/lwList" });
			sessionStorage.removeItem("out_trade_no");
          } else {
            alert("支付失败！");
			_this.$router.push({ path: "/lwList" });
			sessionStorage.removeItem("out_trade_no");
          }
        })
        .catch(function(reason) {
          alert("支付超时！");
		  _this.$router.push({ path: "/lwList" });
		  sessionStorage.removeItem("out_trade_no");
        });
    }
  }
};
</script>
